import { memo, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { setOpen } from '../../Redux/Services/headerSlice';
import { NotificationSound } from '../CommonComponents/CommonNotification';
import { ApiCall } from '../CommonComponents/CustomHooks';
import { GetSession, RemoveSession } from '../CommonComponents/cryptoUtils';

const Sidebar = () => {
    const [menus, setMenus] = useState([]);
    const [ToggleforMobileView, setToggleforMobileView] = useState(false);
    const dispatch = useDispatch()
    const { open } = useSelector((state) => state.header);
    const userType = GetSession('cookies', 'loginUserType');
    const theme = GetSession('localStorage', 'theme');
    const user = GetSession('cookies', 'user');
    const getSidebar = async () => {
        const Token = await GetSession('cookies', 'token');
        let LoginUserCode = await GetSession('cookies', 'loginUserCode');
        let UserName = await GetSession('cookies', 'userName');
        let SearchText = ''

        if (!Token) {
            RemoveSession('cookies', 'token')
            RemoveSession('cookies', 'loginUserCode')
            RemoveSession('cookies', 'userName')
        } else {
            if (typeof LoginUserCode !== 'string') {
                LoginUserCode = String(LoginUserCode);
            }
            const data = {
                UserName: UserName,
                SearchText: SearchText
            };
            let res = await ApiCall(`/api/User/GetMenu`, data)
            if (res.status === 'SUCCESS') {
                setMenus(res.getMenu)
            } if (res.status === "ERROR") {
                setMenus([])
            }
            if (res.status === 'EXPIRED') {
                await NotificationSound(res.status, res.message, res.focus);
            }
        }
    }

    useEffect(() => {
        function handleresize() {
            if (window.innerWidth < 1200) {
                dispatch(setOpen(false));
            } else {
                dispatch(setOpen(true));
            }
        }
        handleresize();
        window.addEventListener("resize", handleresize);
        return () => window.addEventListener("resize", handleresize);
    }, [ToggleforMobileView])

    useEffect(() => {
        getSidebar()
    }, []);

    useEffect(() => {
        if (!userType || !user)
            NotificationSound('EXPIRED', 'EXPIRED')
    }, [userType, user]);

    return (
        <>
            <aside id="sidebar" className="sidebar" style={open ? {} : { left: "-250px" }}>
                <ul className="sidebar-nav" id="sidebar-nav">
                    {menus !== null &&
                        (menus.map((menu, index) => (
                            <li className="nav-item" style={{ cursor: "pointer" }} key={index}>
                                {menu.getSubMenu !== null ?
                                    (
                                        <>
                                            <div
                                                className={`nav-link collapsed cursor-pointer`}
                                                data-bs-target={`#${(menu.menuText).replaceAll(' ', '').replaceAll('&', '')}`}
                                                data-bs-toggle="collapse"
                                            >
                                                <i className={menu.cssClass} />
                                                <span>{menu.menuText}</span>
                                                <i className="bi bi-chevron-down ms-auto" />
                                            </div>

                                            <ul
                                                id={`${(menu.menuText).replaceAll(' ', '').replaceAll('&', '')}`}
                                                className={`nav-content collapse open sidebar-submenu ${menu.getSubMenu[0].mpageID === localStorage.getItem('ID') ? 'show' : ''}`}
                                                data-bs-parent="#sidebar-nav"
                                            >
                                                {menu.getSubMenu.map((subMenu, i) => (
                                                    <li key={i} className='mx-2 my-1' onClick={() => {
                                                        localStorage.setItem('ID', subMenu.mpageID)
                                                        setToggleforMobileView(!ToggleforMobileView)
                                                    }}>
                                                        <NavLink to={`/${(subMenu.pageUrl)}`}
                                                            id={subMenu.pageID}>
                                                            <i className={subMenu.cssClass} />
                                                            <span>{(subMenu.menuText).trim()}</span>
                                                        </NavLink>
                                                    </li>
                                                ))}
                                            </ul>
                                        </>
                                    ) : (
                                        <NavLink
                                            className="nav-link collapsed"
                                            cursor-pointer
                                            key={index}
                                            to={`/${menu.pageUrl}`}
                                        >
                                            <i className={menu.cssClass} />
                                            <span>{menu.menuText}</span>
                                            <i className="bi bi-chevron-down ms-auto" />
                                        </NavLink>)}
                            </li>
                        )))}
                </ul>

                {/* Static Image - Placed below the menu */}
                <div className="align-items-center" style={{ paddingleft: '0px', paddingright: '0px' }} >
                    <img src={theme === "light" ? './images/LeftMenuBanner.jpg' : './images/LeftMenuBannerDark.jpg'} alt="Customer Care Detail" className="static-banner-image"
                        style={{
                            width: '100%',
                            height: 'auto',
                            maxHeight: '250px',
                            borderRadius: '8px',
                            boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
                        }} />
                </div>
            </aside>
        </>
    )
}
export default memo(Sidebar)
